import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import style from './style.module.less';

const SummaryBar = ({ className = '', data, datumClassName = '' }) => {
  return (
    <div className={classnames(style['summary-wrapper'], className)}>
      {data.map((datum, index) => {
        return (
          <div key={index} className={classnames(style.datum, datumClassName)}>
            <div className={style['datum-value']}>{datum.value}</div>
            <div className={style['datum-title']}>{datum.title}</div>
          </div>
        );
      })}
    </div>
  );
};

SummaryBar.propTypes = {
  className: PropTypes.string,
  datumClassName: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.node,
      value: PropTypes.node,
    }),
  ).isRequired,
};

export default SummaryBar;
